<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Notificaciones</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mb-3 pb-3">
        @if(showNotifications){
            <div class="fade-in col col-sm-11 tag-row ms-1 ms-lg-4 me-1 ps-lg-1 alerts-row ps-4 pe-4 pe-md-0 mb-sm-2 mb-3 mt-4 cursor-pointer" (click)="subscribeToNotifications()" role="button">
                <div class="row align-items-center p-2 p-sm-3">
                    <div class="col-auto parpadea"><i class="bi bi-bell-fill"></i></div>
                    <div class="col alerts-row-text">
                        <div class="alerts-row-text-title">ACTIVAR LAS NOTIFICACIONES</div>
                        <div class="alerts-row-text-description">Para que puedas recibir las novedades</div>
                    </div>
                    <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                </div>
            </div>
        }
        <div class="text-p p-3 pb-1">
            <i class="bi bi-bell"></i> Notificaciones: <b [ngClass]="(estadoNotificaciones | async)==='granted' ? 'text-success' : 'text-danger'">{{(estadoNotificaciones | async)==='granted' ? 'Activadas' : 'Desactivadas'}}</b>
        </div>

        @if (error()) {
            <div class="alert alert-danger mt-4" role="alert">
                <small>{{ error() }}</small>
            </div>
        }
        @if (message()) {
            <div class="alert alert-success mt-4" role="alert">
                <small>{{ message() }}</small>
            </div>
        }

        <div class="text-p p-3 pb-1">
            <h2>Dispositivos asociados ({{dispositivos.length}})</h2>
        </div>
        <div class="row p-2 px-4 align-items-center" *ngFor="let dispositivo of dispositivos" [class.active]="isActiveDispositivo(dispositivo.id!)">
            <div class="col-auto cursor-pointer" role="button" (click)="enviarPrueba(dispositivo.id!)"><i [ngClass]="{'bi bi-phone' : dispositivo.x_device_type == 'mobile', 'bi bi-pc-display' : dispositivo.x_device_type != 'mobile'}"></i></div>
            <div class="col"><div class="col-10 text-title-item">{{dispositivo.x_browser_name}} {{dispositivo.x_browser_version ? ' - Ver. ' + dispositivo.x_browser_version : ''}}</div>
            <div class="col-10 text-detail-item">
                {{dispositivo.x_device_model ? dispositivo.x_device_model : ''}} {{dispositivo.x_device_type ? '| ' + dispositivo.x_device_type : ''}}
                {{dispositivo.x_os_name ? '| ' + dispositivo.x_os_name : ''}} {{dispositivo.x_os_version ? ' - Ver. ' + dispositivo.x_os_version : ''}}
            </div></div><div class="col-auto"><a (click)="eliminarDispositivo(dispositivo.id!)"><i class="bi bi-trash"></i></a></div>
        </div>
    </div>
</div>
